import { graphql } from 'react-relay';

export const refetchProfileDraftsTabQuery = graphql`
    query refetchProfileDraftsTabQuery(
        $username: String = ""
        $walletAddress: String = ""
        $fetchDrafts: Boolean!
        $draftsFirst: Int = 8
        $draftsCursor: String
    ) {
        viewer {
            ...NftProfileSectionDrafts_viewer
            ...collectorTabConfig_viewer @relay(mask: false)
        }
    }
`;
